var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({class:{
    'text-link': true,
    'text-link-small': _vm.size === 'small',
    'text-link-large': _vm.size === 'large'
  }},'a',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }